import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { FormattedMessage as T } from "react-intl";
import { useQuery } from "react-query";
import { PrintReferenceRequest } from "services/KnowfullyAdminClient";

type PrintReferenceDisplayerProps = {
  enablePrintReference: boolean;
  organizationId: string;
};

const PrintReferenceDisplayer = ({
  enablePrintReference,
  organizationId,
}: PrintReferenceDisplayerProps) => {
  const { applicationInstanceSettingService } = useGlobalContext();

  const { data, isLoading, isError } = useQuery(["enablePrintReference"], () =>
    applicationInstanceSettingService.isPrintReferenceEnabled(
      PrintReferenceRequest.fromJS({
        organizationId,
      })
    )
  );

  const enablePrintReferenceAppInstanceLevel = data?.data!;

  if (isLoading) {
    return <CircularProgress size={16} />;
  }

  if (isError) {
    return (
      <span>
        <T id="fetchError" />
      </span>
    );
  }

  return enablePrintReferenceAppInstanceLevel && enablePrintReference ? (
    <CheckIcon />
  ) : (
    <CloseIcon />
  );
};

export default PrintReferenceDisplayer;
